import { forEach, getParameterByName } from '../../helpers/utilities';
import { Detail } from '../detail';

export class Accordion {
    private items: NodeList;
    private subNavLinks: NodeList;
    private details: Detail[] = [];

    constructor(container: HTMLElement) {
        this.items       = container.querySelectorAll('[data-accordion-item]');
        this.subNavLinks = container.querySelectorAll('.js-accordion__sub-nav-link');

        // Generate our detail blocks.
        if(this.items) {
            forEach(this.items, ({}, item: Element) => {
                this.details.push(new Detail(item));
            });
        }

        this.bindEvents();
    }


    /**
     * Bind our events
     * 
     * @private
     * @memberof Accordion
     */
    private bindEvents(): void {

        // Detail events
        forEach(this.items, ({}, item: Element) => {
            item.addEventListener('open', (event) => {
                this.onDetailOpen((event as any).detail);
            });
            item.addEventListener('close', () => {
                this.onDetailClose();
            });
        });

        
        // When clicking the sub nav links
        forEach(this.subNavLinks, ({}, link: HTMLAnchorElement) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                const targetID = getParameterByName('detail', link.href);
                const targetDetail = this.details.filter((detail: Detail) => detail.id === targetID);
                if(targetDetail) {
                    targetDetail[0].open();
                    if(history.pushState) history.pushState('', '', link.href);
                }
            });
        });
    }


    /**
     * Closes all other open details, and updates the sub nav.
     * 
     * @param targetDetail The Detail toggled
     */
    private onDetailOpen(targetDetail: Detail): void {

        // Close all except the target detail
        forEach(this.details, ({}, detail: Detail) => {
            if(detail !== targetDetail) {
                detail.close();
            }
        });

        // Toggle the sub nav links
        forEach(this.subNavLinks, ({}, link: HTMLAnchorElement) => {
            const targetID = getParameterByName('detail', link.href);

            if(targetID === targetDetail.id && targetDetail.isOpen) {
                link.classList.add('c-sticky-side-nav__link--is-active');
            } else {
                link.classList.remove('c-sticky-side-nav__link--is-active');
            }
        });
    }


    /**
     * When a detail closes, this checks if there are any details left open, if not then it removes the active link from
     * from the sub nav
     * 
     * @private
     * @memberf Accordion
     */
    private onDetailClose(): void {
        const hasOpenDetails = this.details.filter((detail: Detail) => detail.isOpen).length;

        if(!hasOpenDetails) {

            // Remove the active state from the links
            forEach(this.subNavLinks, ({}, link: HTMLAnchorElement) => {
                link.classList.remove('c-accordion__sub-nav-link--is-active');
            });

            // Reset the url
            if(history.pushState) history.pushState('', '', window.location.pathname);
        }
    }
}
